function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ChannelLogo from "@common/components/ChannelLogo";
import OrderItem from "@common/components/order/OrderItem";
import ActivityIndicator from "@common/components/order/subscriptions/ActivityIndicator";
import AdditionalItemsOverlay from "@common/components/order/subscriptions/AdditionalItemsOverlay";
import { formatPrice, replaceWith } from "@common/services/helpers";
import { getItemPrice } from "@common/utils/helpers";
import { isEmpty, isNil } from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
var MAX_CHANNELS_TO_SHOW_DESKTOP = 4;
var MAX_CHANNELS_TO_SHOW_MOBILE = 3;
var AddonItem = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(AddonItem, Component);
    var _super = _create_super(AddonItem);
    function AddonItem() {
        _class_call_check(this, AddonItem);
        var _this;
        _this = _super.apply(this, arguments);
        _define_property(_assert_this_initialized(_this), "getMaxChannelsToShow", function() {
            var screenType = _this.props.screenType;
            return screenType.web || screenType.tablet ? MAX_CHANNELS_TO_SHOW_DESKTOP : MAX_CHANNELS_TO_SHOW_MOBILE;
        });
        _define_property(_assert_this_initialized(_this), "renderChannels", function() {
            var _addon_metaData_channels, _addon_metaData;
            var _this_props = _this.props, addon = _this_props.addon, logos = _this_props.logos;
            return addon === null || addon === void 0 ? void 0 : (_addon_metaData = addon.metaData) === null || _addon_metaData === void 0 ? void 0 : (_addon_metaData_channels = _addon_metaData.channels) === null || _addon_metaData_channels === void 0 ? void 0 : _addon_metaData_channels.slice(0, _this.getMaxChannelsToShow()).map(function(subscriptionChannelId) {
                var _addon_metaData_restrictedChannelsLogo;
                var restrictedLogo = addon === null || addon === void 0 ? void 0 : (_addon_metaData_restrictedChannelsLogo = addon.metaData.restrictedChannelsLogo) === null || _addon_metaData_restrictedChannelsLogo === void 0 ? void 0 : _addon_metaData_restrictedChannelsLogo[subscriptionChannelId];
                return /*#__PURE__*/ _jsx("div", {
                    className: "channel-logo",
                    children: /*#__PURE__*/ _jsx(ChannelLogo, {
                        hasName: false,
                        channelLogo: restrictedLogo ? {
                            svgCentered: restrictedLogo,
                            svgLeft: restrictedLogo,
                            name: subscriptionChannelId,
                            id: subscriptionChannelId,
                            access: true,
                            locked: false
                        } : logos[subscriptionChannelId],
                        channelLogoURL: restrictedLogo !== null && restrictedLogo !== void 0 ? restrictedLogo : null,
                        restricted: !!restrictedLogo,
                        isCentered: true,
                        redirectToChannel: false,
                        isInSubscriptionPage: true
                    })
                }, subscriptionChannelId);
            });
        });
        _define_property(_assert_this_initialized(_this), "renderMoreView", function() {
            var _addon_metaData_channels, _addon_metaData, _addon_metaData_channels1, _addon_metaData1;
            var _this_props = _this.props, addon = _this_props.addon, addonPrismic = _this_props.addonPrismic, additionalTitleComponent = _this_props.additionalTitleComponent, customContentComponent = _this_props.customContentComponent, onAdditionalItemClick = _this_props.onAdditionalItemClick;
            var hasAdditionalChannels = (addon === null || addon === void 0 ? void 0 : (_addon_metaData = addon.metaData) === null || _addon_metaData === void 0 ? void 0 : (_addon_metaData_channels = _addon_metaData.channels) === null || _addon_metaData_channels === void 0 ? void 0 : _addon_metaData_channels.length) > _this.getMaxChannelsToShow();
            var hasCustomView = !isEmpty(customContentComponent);
            if (!hasAdditionalChannels && !additionalTitleComponent) return null;
            return /*#__PURE__*/ _jsx(AdditionalItemsOverlay, {
                channelsCount: ((addon === null || addon === void 0 ? void 0 : (_addon_metaData1 = addon.metaData) === null || _addon_metaData1 === void 0 ? void 0 : (_addon_metaData_channels1 = _addon_metaData1.channels) === null || _addon_metaData_channels1 === void 0 ? void 0 : _addon_metaData_channels1.length) || 0) - _this.getMaxChannelsToShow(),
                content: additionalTitleComponent,
                onClick: onAdditionalItemClick
            });
        });
        _define_property(_assert_this_initialized(_this), "renderPriceCheckbox", function() {
            var _this_props = _this.props, addon = _this_props.addon, active = _this_props.active, i18n = _this_props.i18n, recurring = _this_props.recurring, addonPrismic = _this_props.addonPrismic, _this_props_selectedPeriod = _this_props.selectedPeriod, selectedPeriod = _this_props_selectedPeriod === void 0 ? null : _this_props_selectedPeriod, currencyConversion = _this_props.currencyConversion;
            var _getItemPrice = getItemPrice(addon, addonPrismic, currencyConversion), originalPrice = _getItemPrice.originalPrice, discountedPrice = _getItemPrice.discountedPrice, hasPromoPrice = _getItemPrice.hasPromoPrice;
            var shouldRenderPeriod = !isNil(selectedPeriod) && selectedPeriod > 1 && recurring;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "price-container column ".concat(hasPromoPrice ? "has-promo-price" : ""),
                        children: [
                            hasPromoPrice && /*#__PURE__*/ _jsx("span", {
                                className: "original-price",
                                children: formatPrice(originalPrice, "EUR")
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "row",
                                children: [
                                    shouldRenderPeriod && /*#__PURE__*/ _jsxs("span", {
                                        className: "plan-period",
                                        children: [
                                            selectedPeriod,
                                            " ",
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "plan-period-x",
                                                children: "x"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "discounted-price",
                                        children: formatPrice(hasPromoPrice ? discountedPrice : originalPrice, "EUR")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "checkbox-button-container column",
                        children: /*#__PURE__*/ _jsx("span", {
                            className: "checkbox-button ".concat(active ? "active" : "")
                        })
                    })
                ]
            });
        });
        return _this;
    }
    _create_class(AddonItem, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, addon = _this_props.addon, addonPrismic = _this_props.addonPrismic, _this_props_single = _this_props.single, single = _this_props_single === void 0 ? false : _this_props_single, i18n = _this_props.i18n, _this_props_active = _this_props.active, active = _this_props_active === void 0 ? false : _this_props_active, onClick = _this_props.onClick, _this_props_customContentComponent = _this_props.customContentComponent, customContentComponent = _this_props_customContentComponent === void 0 ? null : _this_props_customContentComponent, _this_props_hideIcon = _this_props.hideIcon, hideIcon = _this_props_hideIcon === void 0 ? false : _this_props_hideIcon, _this_props_disabled = _this_props.disabled, disabled = _this_props_disabled === void 0 ? false : _this_props_disabled, _this_props_plain = _this_props.plain, plain = _this_props_plain === void 0 ? false : _this_props_plain, _this_props_loading = _this_props.loading, loading = _this_props_loading === void 0 ? false : _this_props_loading, _this_props_owned = _this_props.owned, owned = _this_props_owned === void 0 ? false : _this_props_owned, _this_props_alreadyInAddonName = _this_props.alreadyInAddonName, alreadyInAddonName = _this_props_alreadyInAddonName === void 0 ? "" : _this_props_alreadyInAddonName, _this_props_alreadyInPlanName = _this_props.alreadyInPlanName, alreadyInPlanName = _this_props_alreadyInPlanName === void 0 ? "" : _this_props_alreadyInPlanName, renderTopRightCornerExtra = _this_props.renderTopRightCornerExtra, available = _this_props.available;
                if (isEmpty(addon) || isEmpty(addonPrismic)) {
                    return null;
                }
                var title = addonPrismic.title, subtitle = addonPrismic.subtitle, image = addonPrismic.image;
                var hasCustomView = !isEmpty(customContentComponent);
                var statusText = !available ? alreadyInPlanName : !isEmpty(alreadyInAddonName) ? alreadyInAddonName : alreadyInPlanName;
                var status = !available ? "unavailable" : !isEmpty(statusText) ? "included" : owned ? "active" : "";
                var additionalText = !available ? i18n.order.unavailableIn : !isEmpty(statusText) ? i18n.order.includedIn : "";
                return /*#__PURE__*/ _jsx(OrderItem, {
                    single: single,
                    onClick: onClick,
                    active: active,
                    disabled: disabled || !available,
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "addon-item ".concat(loading ? "loading-anim" : "", " ").concat(hasCustomView ? "has-custom-view" : ""),
                        children: [
                            !hideIcon && /*#__PURE__*/ _jsx("div", {
                                className: "icon-holder ".concat(isEmpty(image.url) ? "hidden" : ""),
                                children: /*#__PURE__*/ _jsx("img", {
                                    src: image.url
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "content-container column",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "row remaining-content",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "column",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "addon-title",
                                                        children: title.text
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "addon-subtitle",
                                                        children: subtitle.text
                                                    })
                                                ]
                                            }),
                                            renderTopRightCornerExtra && /*#__PURE__*/ _jsx("div", {
                                                className: "top-right-overlay",
                                                children: renderTopRightCornerExtra()
                                            }),
                                            !plain && /*#__PURE__*/ _jsx("div", {
                                                className: "price-checkbox-container row",
                                                children: owned || !isEmpty(statusText) || !available ? /*#__PURE__*/ _jsx(ActivityIndicator, {
                                                    status: status,
                                                    statusText: statusText,
                                                    additionalText: additionalText
                                                }) : this.renderPriceCheckbox()
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "channels",
                                        children: hasCustomView ? customContentComponent : this.renderChannels()
                                    })
                                ]
                            }),
                            this.renderMoreView()
                        ]
                    })
                });
            }
        }
    ]);
    return AddonItem;
}(Component);
var mapStateToProps = function(param) {
    var logos = param.logos, i18n = param.i18n, screenType = param.screenType, userDetails = param.userDetails;
    return {
        logos: logos,
        i18n: i18n,
        screenType: screenType,
        userDetails: userDetails
    };
};
export default connect(mapStateToProps, {})(AddonItem);
